import { fetcher } from '@commenda/utils';

/**
 * Replace a member's firm-granted client access in a single request.
 *
 * `companyIds` is the complete desired set, not an addition: clients left out are revoked. Clients a user group
 * grants are the group's to manage and are ignored here in both directions. Applied in one transaction, so a
 * partial assignment is not a state the caller has to handle.
 */
export async function assignMemberToAffiliateFirmClients(
  affiliateFirmId: string,
  userId: string,
  companyIds: number[]
) {
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/clients/members/${userId}`,
    {
      method: 'POST',
      body: { companyIds },
    }
  );

  return response;
}
